import { FinalImpactScoreType } from '@upright/common/model/output/scores/types';
import { RenderViewImpactChartParams } from '@upright/common/renderer/component-types/types-render-view-impact-chart';
import styled, { css } from 'styled-components';
import { SortableTable } from '../../../../../common/generic/content/tables/sortable-table';
import { getDefaultTableStyle } from '../../../../../common/upright/model/output/tables/table-styles';
import { useRenderViewContext } from '../../../context';
import { toChartData } from '../../../utils';
import { getTableData } from './table-data';

export function RenderViewLegendTable(props: { params: Pick<RenderViewImpactChartParams, 'scoreType'> }) {
  const { params } = props;
  const context = useRenderViewContext();

  const items = context.options.items;
  const data = context.data;

  const chartData = toChartData(items || [], data || []);
  const tableData = getTableData(chartData, params.scoreType === FinalImpactScoreType.ABSOLUTE);
  if (!items || !data) {
    return <></>;
  }

  return (
    <Root>
      <SortableTable
        data={tableData}
        disableSort={true}
        onSortKeyChange={() => {
          return;
        }}
        onSortOrderChange={() => {
          return;
        }}
        disableDownloadLink
        hideRowLines
        dynamicWidth
        styleOverride={styleOverride}
      />
    </Root>
  );
}

const Root = styled.div``;

const styleOverride = css`
  ${getDefaultTableStyle({})}
  thead td {
    border-bottom: none;
  }
  tbody td {
    padding-top: 4px;
    padding-bottom: 4px;
    border-top: none;
  }
`.join('');
